import { jwtDecode } from 'jwt-decode'

export const decodeJwt = (token: string) : any => {
  return token ? jwtDecode(token) : token;
}